export function generatePersonSchema (person, path) {
  return {
    '@type': 'Person',
    '@id': `https://querobolsa.com.br${path}#author`,
    name: person.name,
    url: person.url,
  }
}
